export const navLinks = [
  { id: "overview", label: "平台概览" },
  { id: "access", label: "访问流程" },
  { id: "entries", label: "入口类型" },
  { id: "latest", label: "最新地址" },
  { id: "verify", label: "识别真伪" },
  { id: "faq", label: "常见问题" },
];

export const heroHighlights = [
  {
    icon: "ri-bookmark-3-line",
    title: "入口汇总",
    desc: "把网页、移动端与备用线路的入口判断方法集中在一页，少走弯路。",
  },
  {
    icon: "ri-map-pin-time-line",
    title: "最新地址",
    desc: "说明如何获取当前有效地址，以及如何长期保存、随时取用。",
  },
  {
    icon: "ri-shield-check-line",
    title: "防骗提示",
    desc: "教你分辨仿冒页面与诱导跳转，避开虚假站点带来的风险。",
  },
];

export const overviewStats = [
  { value: "4", unit: "类", label: "常见入口类型" },
  { value: "6", unit: "步", label: "首页访问流程" },
  { value: "8", unit: "条", label: "访问问题排查" },
  { value: "5", unit: "种", label: "最新地址获取渠道" },
];

export const overviewFeatures = [
  {
    icon: "ri-layout-grid-line",
    title: "信息聚合导航",
    desc: "把平时分散在多个来源的入口、地址与使用方法整理到同一页，减少反复搜索和翻找的时间。",
  },
  {
    icon: "ri-device-line",
    title: "多端访问说明",
    desc: "覆盖桌面浏览器与移动端浏览器在地址输入、页面加载、安全提示上的差异，照顾不同设备的使用习惯。",
  },
  {
    icon: "ri-route-line",
    title: "线路与备用方案",
    desc: "解释主线路与备用线路各自的适用场景，给出切换的先后顺序，帮你在打不开时快速找到替代路径。",
  },
  {
    icon: "ri-fingerprint-line",
    title: "真伪辨别要点",
    desc: "提供一套通用的页面核对方法，从域名、页面结构到跳转行为逐项确认，降低误入仿冒站点的概率。",
  },
];

export const accessSteps = [
  {
    step: "01",
    title: "确认最新地址来源",
    desc: "优先从官方公告、订阅通知等相对稳定的渠道获取地址，避免直接点击来路不明的短链接或弹窗广告中的地址。",
    tip: "来源越正式，地址的有效性越有保障。",
  },
  {
    step: "02",
    title: "在浏览器地址栏输入",
    desc: "手动输入或粘贴完整地址，逐字核对拼写。相似字符与多一个后缀的域名，往往是仿冒站点的常见套路。",
    tip: "不要通过陌生聊天消息里的链接直接进入。",
  },
  {
    step: "03",
    title: "打开首页并核对标识",
    desc: "进入后先别急着操作，观察页面名称、导航结构、内容分区是否完整、一致。页面残缺或大量错位，通常需要警惕。",
    tip: "结构完整、加载流畅的页面更可能是正规入口。",
  },
  {
    step: "04",
    title: "确认访问环境正常",
    desc: "检查网络是否稳定、浏览器是否为较新版本。如果出现安全拦截提示，先确认提示原因，再决定是否继续。",
    tip: "浏览器更新到最新版本可减少兼容性问题。",
  },
  {
    step: "05",
    title: "收藏为书签",
    desc: "确认页面可正常访问后，把它加入浏览器书签并命名，下次直接点击即可，避免再次搜索时误入其他页面。",
    tip: "书签命名建议写清用途与日期，方便日后辨认。",
  },
  {
    step: "06",
    title: "备用线路切换",
    desc: "若主地址无法打开，按备用线路的先后顺序逐条尝试，并记录哪条可用，作为下次访问的首选。",
    tip: "把可用线路单独记下，比每次重新搜索更省事。",
  },
];

export const entryTabs = [
  {
    key: "web",
    label: "网页入口",
    icon: "ri-global-line",
    title: "桌面浏览器入口",
    desc: "最常见的访问方式，通过电脑浏览器直接打开页面。适合需要大屏浏览、多标签切换的用户。",
    points: [
      "确认浏览器为较新版本，避免页面排版错乱",
      "在地址栏手动核对完整域名后再回车",
      "可使用书签与历史记录快速回到首页",
      "遇到安全提示时先看清提示内容再决定",
    ],
  },
  {
    key: "mobile",
    label: "移动端入口",
    icon: "ri-smartphone-line",
    title: "手机浏览器入口",
    desc: "通过手机自带浏览器或第三方浏览器访问，页面通常会自动适配成单列布局，方便单手操作。",
    points: [
      "优先使用系统自带浏览器或主流浏览器",
      "注意区分浏览器广告与页面本身的内容",
      "可把页面添加到手机桌面以便一键访问",
      "移动网络不稳定时可切换至无线网络再试",
    ],
  },
  {
    key: "backup",
    label: "备用线路",
    icon: "ri-route-line",
    title: "备用线路说明",
    desc: "当主线路因网络波动或维护暂时无法访问时，备用线路提供一个替代路径，帮助维持基本访问。",
    points: [
      "主线路无法打开时再启用，避免频繁切换",
      "按顺序尝试，记录每一条线路的可用情况",
      "备用线路同样需要核对页面是否正规",
      "长期可用后可单独整理成一份清单",
    ],
  },
  {
    key: "mirror",
    label: "镜像入口",
    icon: "ri-links-line",
    title: "镜像入口说明",
    desc: "镜像入口通常与主站内容保持一致，用于分担访问压力。使用前同样需要确认其来源是否可靠。",
    points: [
      "核对镜像页面的结构是否与主站一致",
      "留意镜像地址是否被频繁更换",
      "不轻信要求额外下载或授权的镜像页",
      "优先选择来源清晰、长期稳定的入口",
    ],
  },
];

export const latestAddressChannels = [
  {
    icon: "ri-megaphone-line",
    name: "官方公告页",
    how: "在平台对外公示的公告区域查看地址变更说明。",
    reliability: "高",
    note: "通常是最及时、最权威的信息来源。",
  },
  {
    icon: "ri-mail-send-line",
    name: "订阅与通知",
    how: "通过你事先订阅的邮件或通知渠道接收更新提醒。",
    reliability: "中高",
    note: "注意确认发件方身份，避免钓鱼邮件。",
  },
  {
    icon: "ri-bookmark-3-line",
    name: "既往收藏记录",
    how: "翻找浏览器书签与历史记录中曾经可用的地址。",
    reliability: "中",
    note: "旧地址可能已失效，需重新核对。",
  },
  {
    icon: "ri-search-eye-line",
    name: "搜索与社群渠道",
    how: "通过搜索引擎或讨论社群了解近期更新的线索。",
    reliability: "低",
    note: "信息来源混杂，务必自行辨别后再使用。",
  },
  {
    icon: "ri-refresh-line",
    name: "页面内提示",
    how: "部分页面在地址调整时会给出跳转或提示信息。",
    reliability: "中",
    note: "仔细阅读提示文字，确认跳转目标再继续。",
  },
];

export const authenticityGood = [
  "域名、页面名称与平台信息相互对应，无明显错字",
  "页面结构完整，导航、分区、内容层级清晰",
  "加载过程平稳，不出现频繁自动跳转",
  "不强制要求额外下载软件或授权敏感权限",
  "页面内容与平台定位一致，无夸大诱导话术",
];

export const authenticityBad = [
  "域名与已知名称高度相似但存在细微差异",
  "页面残缺、排版错乱或大量弹窗遮挡内容",
  "一打开就自动跳转到其他陌生页面",
  "反复弹出下载、安装或充值等诱导提示",
  "要求填写与浏览无关的个人信息或验证码",
];

export const faqItems = [
  {
    q: "蓝莓视频首页打不开怎么办？",
    a: "先确认网络连接是否正常，再检查输入的地址是否完整、拼写是否准确。若仍无法打开，可尝试更换浏览器或按备用线路顺序尝试。把打不开时的提示信息记录下来，有助于判断问题出在网络还是地址本身。",
  },
  {
    q: "提示页面不安全，是否应该继续访问？",
    a: "不要盲目继续。先看清提示的具体原因：如果是证书或来源不明导致，应停止访问并改为从可信渠道重新获取地址；如果是可忽略的兼容性提示，则需要你自行判断风险后再决定。安全提示的核心作用是提醒你核对来源。",
  },
  {
    q: "页面加载很慢是什么原因？",
    a: "常见原因包括本地网络波动、访问高峰期、浏览器缓存过多以及设备性能不足。可以尝试刷新页面、清理缓存、切换网络，或用另一台设备对比测试，从而判断是普遍问题还是本地问题。",
  },
  {
    q: "之前保存的地址突然失效了？",
    a: "地址发生调整属于常见情况，通常与线路维护或运营策略有关。建议通过官方公告或订阅渠道重新获取当前地址，并更新你的书签，避免一直使用已失效的旧地址。",
  },
  {
    q: "手机上能正常打开，电脑上却不行？",
    a: "不同设备的网络环境、DNS 设置与浏览器版本可能不同。可以先对比两者所连接的 Wi-Fi 或流量网络，再检查电脑浏览器的版本与插件设置，逐步缩小问题范围。",
  },
  {
    q: "访问时需要登录或注册吗？",
    a: "是否需要账号取决于平台自身的设定。遇到要求登录的页面时，请务必确认页面是否正规，不要在来源不明的页面输入账号、密码或验证码等敏感信息。",
  },
  {
    q: "如何判断找到的是不是仿冒站点？",
    a: "可以从域名拼写、页面结构、跳转行为与话术四个角度核对。正规页面通常结构完整、跳转克制、话术平实；仿冒页面往往域名相似、弹窗频繁、诱导明显。发现可疑应立刻离开并改用可信来源。",
  },
  {
    q: "备用线路应该怎么选择？",
    a: "建议按来源的可靠程度排序：优先使用官方或长期稳定的线路，其次再考虑其他来源。每次记录下可用与不可用的结果，形成自己的常用清单，这样下次遇到问题就能快速切换。",
  },
];

export const safetyTips = [
  {
    icon: "ri-lock-2-line",
    title: "保护好账号与验证码",
    desc: "不要在来源不明的页面输入账号、密码或短信验证码，正规平台不会通过弹窗索要这些信息。",
  },
  {
    icon: "ri-download-2-line",
    title: "谨慎对待下载请求",
    desc: "页面若反复提示下载安装包或插件，先暂停操作，确认来源可信后再做决定。",
  },
  {
    icon: "ri-eye-off-line",
    title: "留意页面跳转",
    desc: "打开后若被自动带到无关页面，建议立即关闭并重新从可信渠道进入。",
  },
  {
    icon: "ri-history-line",
    title: "定期整理书签",
    desc: "把可用地址单独归类，并标注重获时间，方便在地址变动时快速更新。",
  },
  {
    icon: "ri-parent-line",
    title: "合理安排使用时间",
    desc: "注意作息与用眼健康，把访问行为安排在合适的时间段，避免影响正常休息。",
  },
  {
    icon: "ri-information-line",
    title: "以官方信息为准",
    desc: "遇到说法不一时，以官方渠道发布的信息为准，不轻信未经证实的传闻。",
  },
];

export const changeReasons = [
  {
    title: "域名与线路调整",
    desc: "出于运营与稳定性的考虑，平台会不定期对域名或线路进行优化调整，原地址可能随之更新。",
  },
  {
    title: "机房维护与升级",
    desc: "服务器维护或系统升级期间，部分地址可能短暂不可用，通常在维护结束后恢复正常。",
  },
  {
    title: "网络环境差异",
    desc: "不同地区、不同运营商的网络策略存在差异，可能导致同一条地址在部分环境下无法访问。",
  },
  {
    title: "访问压力疏导",
    desc: "在访问量较大的时段，平台可能通过分流或多线路方式分散压力，地址表现也会随之变化。",
  },
];